import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322d66ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-item" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "name xag-ellipsis" }
const _hoisted_4 = { class: "sn xag-ellipsis" }

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-info-item',
  props: {
    data: { default: () => null }
  },
  setup(__props: any) {

const props = __props as { data: {
      name: string
      sn: string
      logo_url?: string
    } };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["photo", !props.data?.logo_url ? 'default-bg' : '']),
      style: _normalizeStyle('--bg-url:url(' + props.data?.logo_url + ')')
    }, null, 6),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.data?.name || '-'), 1),
      _createElementVNode("div", _hoisted_4, "SN: " + _toDisplayString(props.data?.sn), 1)
    ])
  ]))
}
}

})